import { Box, Typography } from '@mui/material';

export type PhoneCountryOptionRowModel = {
    code: string;
    label: string;
    dialCode: string;
    flagSrc?: string;
    flag?: string;
};

export function PhoneCountryOptionRow({
    country,
    variant,
}: {
    country: PhoneCountryOptionRowModel;
    variant: 'menu' | 'selected';
}) {
    const flag = country.flag ?? '🏳️';

    if (variant === 'selected') {
        return (
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1.5,
                    minWidth: 0,
                    maxWidth: '100%',
                }}
            >
                <Box
                    sx={{
                        width: 24,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    {country.flagSrc ? (
                        <Box
                            component="img"
                            src={country.flagSrc}
                            alt={country.label}
                            loading="lazy"
                            sx={{
                                width: 20,
                                height: 14,
                                display: 'block',
                                borderRadius: 0.5,
                                objectFit: 'cover',
                            }}
                        />
                    ) : (
                        <Typography
                            component="span"
                            sx={{
                                fontSize: 18,
                                lineHeight: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {flag}
                        </Typography>
                    )}
                </Box>

                <Typography variant="body2" noWrap>
                    {country.label}
                </Typography>

                <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                    {country.dialCode}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                width: '100%',
                height: '100%',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                <Box
                    sx={{
                        width: 24,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    {country.flagSrc ? (
                        <Box
                            component="img"
                            src={country.flagSrc}
                            alt={country.label}
                            loading="lazy"
                            sx={{
                                width: 20,
                                height: 14,
                                display: 'block',
                                borderRadius: 0.5,
                                objectFit: 'cover',
                            }}
                        />
                    ) : (
                        <Typography
                            component="span"
                            sx={{
                                fontSize: 18,
                                lineHeight: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {flag}
                        </Typography>
                    )}
                </Box>

                <Typography variant="body2" noWrap>
                    {country.label}
                </Typography>
            </Box>

            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                {country.dialCode}
            </Typography>
        </Box>
    );
}
